import chrono from "chrono-node";
import moment from "moment";

const convertToISOString = (string) => moment(string).utc(string).toISOString();

export default function schemaDate(date) {
  if (!chrono.parse(date).length) {
    return {
      startDate: "",
      endDate: "",
    };
  }

  const parsedStartDate = chrono.parse(date)[0].start;
  const parsedEndDate = chrono.parse(date)[0].end;

  const startDate = typeof parsedStartDate !== "undefined" ?
    convertToISOString(parsedStartDate.date().toString()) : "";

  const endDate = typeof parsedEndDate !== "undefined" ?
    convertToISOString(parsedEndDate.date().toString()) : "";

  return {
    startDate,
    endDate: endDate || startDate,
  };
}



// WEBPACK FOOTER //
// ./assets/pois/utils/schemaDate.js